window.addEventListener('DOMContentLoaded', function () {
  jQuery(function () {
    var instance = new Swiper('.sports-stars__carousel.swiper', {
      slidesPerView: 1.5,
      slidesPerGroup: 1,
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: '.sports-stars__navigation-wrapper .swiper-button-next',
        prevEl: '.sports-stars__navigation-wrapper .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          slidesPerGroup: 2,
        },
        1139: {
          slidesPerView: 'auto',
          slidesPerGroup: 5,
        },
      },
    });
  });
});
